var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid position-relative row vh-100 m-0 p-0 wow fadeIn"},[_c('right-Menu'),_vm._v(" "),_c('div',{staticClass:"col p-3 vh-100 overflow-scroll pr-95px"},[(_vm.checkShowComponent)?_c('tab-header',{attrs:{"tabActiveInParent":_vm.tabActive}}):_vm._e(),_vm._v(" "),(_vm.checkShowComponent)?_c('tab-body',{attrs:{"tabActive":_vm.tabActive.tabID}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2ad0f6c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AdminPanel/AdminPanel.vue
// module id = 679
// module chunks = 0